import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import { ICON_HEIGHT_32, IconNG } from '../../Icon'
import Text from '../../Text'

import * as styles from './ProfileAISummaryWidgetHeaderContentTitle.module.css'

import AIAvatarIcon from '../../../icons/unique/ai/avatar.svg'

function ProfileAISummaryWidgetHeaderContentTitle({
  className = styles.ProfileAISummaryWidgetHeaderContentTitle,
  title,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <div className={className}>
      <IconNG Icon={AIAvatarIcon} size={ICON_HEIGHT_32} />
      <FloatingTooltip
        content={title}
        disabled={!overflow}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <Text className={styles.title} ref={setContentOverflowRef}>
          {title}
        </Text>
      </FloatingTooltip>
    </div>
  )
}

export default ProfileAISummaryWidgetHeaderContentTitle
